import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"hide-on-md mt-5 hide-on-print"},[_c(VRow,{attrs:{"column":""}},[_c(VCol,{attrs:{"cols":"6","sm":"2"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }